<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent;">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-card-text</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.alert') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <v-divider vertical  style="margin: 0 10px 0 10px;"/>
      <template>        
        <v-btn-toggle
          v-model="icon" 
          @change="handleChangeIsModified"
        >
          <v-btn :value="'mdi-information'" @click="content.Icon = 'mdi-information'" text>
            <v-icon>mdi-information</v-icon>
          </v-btn>
          <v-btn :value="'mdi-alert'" @click="content.Icon = 'mdi-alert'" text>
            <v-icon>mdi-alert</v-icon>
          </v-btn>
          <v-btn :value="'mdi-help-circle'" @click="content.Icon = 'mdi-help-circle'" text>
            <v-icon>mdi-help-circle</v-icon>
          </v-btn>
          <v-btn :value="'mdi-check-circle'" @click="content.Icon = 'mdi-check-circle'" text>
            <v-icon>mdi-check-circle</v-icon>
          </v-btn>
          <v-btn :value="'mdi-email'" @click="content.Icon = 'mdi-email'" text>
            <v-icon>mdi-email</v-icon>
          </v-btn>
          <v-btn :value="'mdi-clock'" @click="content.Icon = 'mdi-clock'" text>
            <v-icon>mdi-clock</v-icon>
          </v-btn>
           <v-btn :value="''" @click="content.Icon = ''" text>
             <v-icon style="opacity: 0.2">mdi-cancel</v-icon>
          </v-btn>
        </v-btn-toggle>
      </template>
    </v-toolbar>
    <translate
      v-show="!collapseContent"
      v-model="content.AlertText"
      :languages="languages"
      :label="$t('common.text')"
      @input="handleChangeIsModified"
      style="padding: 0 10px 0 10px;"
    />
    <custom-color-picker
      v-show="!collapseContent"
      label=""
      :width="'100%'"
      :icon="'mdi-format-color-fill'"
      :color="content.Color"
      :onChangeColor="handleChangeColorContent"
      style="margin-right: 5px;"
    />
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import Translate from '@/components/Translate'
  import CustomColorPicker from '@/components/CustomColorPicker'
  export default {
    components: {
      Translate,
      CustomColorPicker
    },
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
      icon: null
    }),
    computed: {
      ...mapState('app',['collapseContent']),
      languages () {
        return this.$store.state.app.Languages
      }
    },
    mounted () {
      this.icon = this.content.Icon
    },
    methods: {
      handleChangeColorContent (color) {
        this.handleChangeIsModified()
        this.content.Color = color
      },
      handleChangeIsModified () {
        this.$store.state.app.isModified = true
      }
    }
  }
</script>

<style scoped>
</style>

